import { FormControl, FormField, FormItem, FormMessage } from '@/components/ui/form';
import { MultiSelect } from './../../multi-select-dropdown';
import { UseFormReturn } from 'react-hook-form';

interface Event {
  value: string;
  label: string;
}
interface CustomEventsFieldProps {
  form: UseFormReturn<any>;
  title?: string;
  eventsList: Event[];
  maxCount?: number;
  placeholder?: string;
  controlClassName?: string;
  resetButton?: () => void;
}

export const CustomEventsField = ({
  form,
  eventsList,
  maxCount = 1,
  placeholder = 'Select events',
  controlClassName = 'w-1/2'
}: CustomEventsFieldProps) => {
  return (
    <FormField
      control={form.control}
      name="customEvents"
      render={({ field }) => (
        <FormItem className="flex flex-col gap-4">
          <FormControl className={controlClassName}>
            <MultiSelect
              options={eventsList}
              onValueChange={field.onChange}
              value={field.value as string[]}
              placeholder={placeholder}
              variant="inverted"
              animation={2}
              maxCount={maxCount}
              allowCustomAdditions={false}
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
